module.exports = __webpack_public_path__ + "files/drugtool_form.csv";